import axios from 'axios';
import VueCookies from 'vue-cookies';
import store from '../store';
import router from '@/router';

const instance = axios.create({
  baseURL: 'https://api.moallem.sch.ir/hire/v1',
});

// Request interceptor
instance.interceptors.request.use(config => {
  // Add Authorization header if token exists
  const token = VueCookies.get("ACCESS-TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }


  let username = store.getters.getUsername;
  if (username) {
    config.params = config.params || {};
    config.params.username = username;
  }

  return config;
});

// Response interceptor
instance.interceptors.response.use(
  response => response,
  async error => {
    const url = error.request?.responseURL || '';
    const status = error.response?.status;

    // Handle 401: Try to refresh token and retry request
    if (status === 401 && !url.includes('refresh')) {
      try {
        await store.dispatch("getAccessTokenFromRefreshToken");
        const newToken = VueCookies.get("ACCESS-TOKEN");

        const originalRequest = error.config;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        console.error('Refresh token failed', refreshError);
        throw refreshError;
      }
    }

    // Handle 5xx server errors
    if (status >= 500 && status <= 600) {
      const currentPath = router.currentRoute.value.path;
      if (!currentPath.endsWith('/500')) {
        router.push({ path: currentPath + '/500' });
      }
    }

    // Handle network errors
    if (error.code === 'ERR_NETWORK') {
      const currentPath = router.currentRoute.value.path;
      if (!currentPath.endsWith('/network-err')) {
        router.push({ path: currentPath + '/network-err' });
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
